import React, { useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import AGSelect from "../../components/AgSelect";
import AGButton from "../../components/Button";
import { httpGET } from "../../utils/ajaxHelper";
import { API_CONSTANT, KEY_ITEM_LOCALSTORAGE } from "../../utils/constant";
import { BackIcon } from "../commerceProfile";
import CardFirmCompare from "./cardFirmCompare";
import { ICompareServiceProps, IInfoCompareService, IParamCompareService, IParamSearchSecondCompareService, ISecondServiceInCompareService, ISelectDropdown } from "./compareService.props";
import { BackResult, Container } from "./compareService.styled";
import CompareServiceTable from "./compareServiceTable";
import Tooltip from "../../components/Tooltip";
import { MESSAGE_TOOLTIP } from "../../utils/messages";

export const CompareServicePage: React.FC<ICompareServiceProps> = (
    {
        ...props
    }: ICompareServiceProps
) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const isMobileScreen = screenWidth <= 768;
    const [searchURLParams, setSearchURLParam] = useSearchParams();
    const navigate = useNavigate();

    const CurrentFirms = searchURLParams.get("firms")
    const CurrentFirmsArray = searchURLParams.get("firms")?.split("_")
    const CurrentMainServices = searchURLParams.get("mainServices")

    const divHeaderRef = useRef<HTMLInputElement>(null);
    const divTableFullRef = useRef<HTMLInputElement>(null);
    const divTableNotFullRef = useRef<HTMLInputElement>(null);

    const [isShow, setIsShow] = useState<boolean>(false)
    const [infoCompareService, setInfoCompareService] = useState<IInfoCompareService | undefined>(undefined)
    const [infoSecondService, setInforSecondService] = useState<ISecondServiceInCompareService | undefined>(undefined)
    const [selectService, setSelectService] = useState<ISelectDropdown | undefined>(undefined)

    const { mutate: getInfoCompareService } = useMutation(
        (
            { mainServices, firms }: IParamCompareService
        ) => httpGET({
            url: API_CONSTANT.COMPARE_SERVICE.MAIN_URL,
            params: {
                "mainServiceIds": JSON.stringify(mainServices),
                "firmIds": JSON.stringify(firms)
            }
        }),
        {
            onSuccess: (rs) => {
                if (rs) {
                    const data = (rs as IInfoCompareService)

                    setInfoCompareService(data)
                    data.mainServices && setSelectService({
                        value: data.mainServices[0].mainServiceId,
                        label: data.mainServices[0].mainServiceName
                    })
                }
            }
        }
    )

    const { mutate: getSubService } = useMutation(
        ({ mainServices, firms }: IParamSearchSecondCompareService
        ) => httpGET({
            url: API_CONSTANT.COMPARE_SERVICE.SUB_SERVICE,
            params: {
                "mainServiceId": mainServices,
                "firmIds": JSON.stringify(firms)
            }
        }),
        {
            onSuccess: (rs) => {
                if (rs) {
                    setInforSecondService(rs)
                }
            }
        }
    )

    const handleScroll = (currentScroll: React.RefObject<HTMLInputElement>) => {
        if (currentScroll.current) {
            if (divHeaderRef.current) divHeaderRef.current.scrollLeft = currentScroll.current.scrollLeft;
            if (divTableFullRef.current)
                divTableFullRef.current.scrollLeft = currentScroll.current.scrollLeft;
            if (divTableNotFullRef.current)
                divTableNotFullRef.current.scrollLeft = currentScroll.current.scrollLeft;
        }
    };

    const containsNonNumericId = (ids: string[]) => {
        const NumericIdRegex = /^\d+$/;

        for (const id of ids) {
            if (!NumericIdRegex.test(id)) {
                return true;
            }
        }

        return false;
    }

    useEffect(() => {
        if (CurrentFirms && CurrentMainServices) {
            const firmIds = CurrentFirms.split("_")
            const mainServiceIds = CurrentMainServices.split("_")

            if (firmIds.length <= 1 || containsNonNumericId(firmIds) || containsNonNumericId(mainServiceIds)) {
                setIsShow(false)
                return;
            }
            setIsShow(true)

            getInfoCompareService({
                firms: firmIds.map(e => +e),
                mainServices: mainServiceIds.map(e => +e)
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchURLParams])

    useEffect(() => {
        if (selectService) {
            getSubService({
                firms: infoCompareService?.inforFirms?.map(e => e.firmID) ?? [],
                mainServices: selectService.value ?? 0
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectService])

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCloseFirm = (firmId: number) => {
        setSearchURLParam(params => {
            const currentFirm = CurrentFirmsArray?.map(e => +e).filter(item => item !== firmId).join("_") ?? "";

            params.set("firms", currentFirm)
            return params;
        })
    }

    return <div className={`my-[10px] ${!isMobileScreen? "p-[0px]": "p-[5px]"}`}>
        <Container>
            {
                CurrentFirms
                    && CurrentMainServices
                    && isShow
                    && infoCompareService
                    && infoCompareService.isExactly
                    && infoSecondService
                    ?
                    <>
                        <div className={`top-[114px] laptop2:top-[104px] mobile2:!top-[68px]  bg-[#e4e4e4] pt-[10px] ${!isMobileScreen? "mt-[0px]": "mt-[70px]"}`}>
                            <BackResult className="w-1/2 mb-[10px] mobile2:ml-[10px]">
                                <AGButton onClick={() => {
                                    // Get the redirect URL from localStorage with a fallback
                                    const baseUrl = localStorage.getItem(KEY_ITEM_LOCALSTORAGE.REDIRECT_URL_COMPARE_SERVICE) || "/search-firms";
                                    
                                    // Construct the new URL with the back-to-results parameter
                                    const url = new URL(baseUrl, window.location.origin);
                                    url.searchParams.set('isBackToRs', 'true');
                                    
                                    // Navigate to the updated URL
                                    window.location.href = url.toString();
                                }} type='Link' icon={<BackIcon />} >
                                    Back to results
                                </AGButton>
                            </BackResult>

                            {
                                isMobileScreen && <div className="p-[10px] bg-white w-full min-h-[54px] mb-[10px] rounded-[10px]">
                                    <div className="flex flex-row space-x-[10px] items-center justify-between">
                                        <AGSelect
                                            options={infoCompareService.mainServices?.map(e => ({
                                                value: e.mainServiceId,
                                                label: e.mainServiceName,
                                            }))}
                                            value={selectService}
                                            onChange={(options: any) => setSelectService(options)}
                                            placeholder="Cybersecurity"
                                            className=""
                                        />

                                        <Tooltip text={MESSAGE_TOOLTIP.PRACTICEL_LEVEL_COMPARE} backgroundColor="#a9a9a9" />
                                    </div>
                                </div>
                            }

                            <div className="flex flex-row min-h-[54px] max-h-[54px] h-[100%] mb-[10px]  mobile2:mb-0 mobile2:sticky mobile2:top-0  border-b-[1px] border-solid border-[#EAEAEA] ">
                                <div className="max-w-[300px] w-full mobile2:max-w-[179px] p-[10px] bg-white rounded-l-[10px] mobile2:rounded-l-none">
                                    <div className="flex flex-row space-x-[10px] items-center justify-between">
                                        <AGSelect
                                            options={infoCompareService.mainServices?.map(item => ({
                                                value: item.mainServiceId,
                                                label: item.mainServiceName,
                                            }))}
                                            value={selectService}
                                            onChange={(options: any) => setSelectService(options)}
                                            placeholder="Cybersecurity"
                                            className="mobile2:hidden"
                                        />

                                        {!isMobileScreen && <Tooltip text={MESSAGE_TOOLTIP.PRACTICEL_LEVEL_COMPARE} backgroundColor="#a9a9a9" />}
                                    </div>
                                </div>
                                <div ref={divHeaderRef} className="flex-1 flex relative no-scrollbar overflow-x-auto bg-white rounded-r-[10px] mobile2:rounded-r-none" onScroll={() => handleScroll(divHeaderRef)}>
                                    <div className=" h-auto flex flex-row w-full">
                                        {/* min-w-min */}
                                        {
                                            infoCompareService.inforFirms?.map((e, index) => <CardFirmCompare key={index} data={e} onCloseFirm={handleCloseFirm} countFirm={infoCompareService.inforFirms?.length ?? 0} />)
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="">
                            <CompareServiceTable
                                refComp={divTableFullRef}
                                onScroll={() => handleScroll(divTableFullRef)}
                                secondService={infoSecondService.secondServiceCommon}
                                inforFirms={infoCompareService.inforFirms}
                                comFirmPracticeLevel={infoSecondService.comFirmPracticeLevel}
                            />

                            <CompareServiceTable
                                refComp={divTableNotFullRef}
                                onScroll={() => handleScroll(divTableNotFullRef)}
                                secondService={infoSecondService.secondServiceNotCommon}
                                inforFirms={infoCompareService.inforFirms}
                                comFirmPracticeLevel={infoSecondService.comFirmPracticeLevel}
                            />
                        </div>

                    </> : null
            }


        </Container>
    </div>
}


export default React.memo(CompareServicePage);

